// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__lqub8","noScroll":"styles_noScroll__D65Sz","scroll":"styles_scroll__Dn9VI","iconWrap":"styles_iconWrap__sL5FX"};
module.exports.__checksum = "53f060476e80"
